import React from "react";
import { Mail, Phone, MapPin, Clock, Shield } from "lucide-react";
import SEO from "../components/SEO";

const Contact = () => {
  return (
    <div className="relative min-h-screen bg-[#0B0F19] text-white">
      <SEO title="Contact - QryptShield" />

      <div className="absolute inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              "linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-blue-600/20 rounded-[100%] blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-12 ">
        <div className="text-center space-y-4 mt-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-semibold">
            <Shield className="w-4 h-4" />
            Talk to the QryptShield team
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight">
            Contact Information
          </h1>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Reach us for support, sales, or partnership inquiries. Our team
            responds during business hours, and emergency support is available
            24/7.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 shadow-xl space-y-4">
            <div className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-blue-400" />
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400">
                  Email
                </p>
                <p className="text-lg font-semibold text-white">
                  info@qryptshield.com
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-blue-400" />
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400">
                  Phone
                </p>
                <p className="text-lg font-semibold text-white">
                  +91 8810316395
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-blue-400 mt-1" />
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400">
                  Address
                </p>
                <p className="text-lg font-semibold text-white">
                  Greater Noida, Uttar Pradesh, India
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 shadow-xl space-y-4">
            <div className="flex items-center gap-3">
              <Clock className="w-5 h-5 text-blue-400" />
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400">
                  Business Hours
                </p>
                <p className="text-lg font-semibold text-white">
                  Monday - Friday: 9:00 AM - 6:00 PM
                </p>
              </div>
            </div>
            <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4 text-sm text-blue-100">
              24/7 Emergency Support Available
            </div>
            <p className="text-gray-400 text-sm">
              For urgent incidents, call or email with the subject line "URGENT"
              to reach our on-call team faster.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-blue-900/30 border border-white/10 rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl font-bold">Need a tailored quote?</h2>
            <p className="text-gray-400 text-sm mt-2 max-w-xl">
              Tell us about your team size, locations, and compliance needs. We
              will share a customized QryptShield rollout plan.
            </p>
          </div>
          <a
            href="mailto:info@qryptshield.com?subject=QryptShield%20Inquiry"
            className="px-5 py-3 rounded-lg bg-blue-600 hover:bg-blue-500 font-semibold text-white transition shadow-lg shadow-blue-900/40"
          >
            Email the Team
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
